// extracted by mini-css-extract-plugin
module.exports = {"v-dark":"#191919","blockingContainer":"BlockingContainer_blockingContainer_1i4fi"};